import Link from '@/lib/siteLink';
import { Car, LogOut, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import { SiteLink } from '@/components/SiteLink';
import NetworkFooter from './NetworkFooter';
import SiteSwitcher from '@/components/SiteSwitcher';

export function AutoHeader() {
  const { user, logout } = useAuth();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass-panel border-b border-gray-200/50 bg-white/90 backdrop-blur-md" data-testid="auto-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/auto" className="flex items-center gap-2" data-testid="auto-logo">
            <img src="/favicon-auto-192.png" alt="" width="32" height="32" className="w-8 h-8 rounded-md object-contain" />
            <span className="font-manrope font-bold text-xl tracking-tight">CarsbikesPrices</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/auto/listings?type=car" className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-testid="nav-cars">Cars</Link>
            <Link to="/auto/listings?type=bike" className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-testid="nav-bikes">Bikes</Link>
            <Link to="/auto/listings?type=scooter" className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-testid="nav-scooters">Scooters</Link>
            <Link to="/auto/compare" className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors">Compare</Link>
            <Link to="/auto/price-pulse" className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-testid="nav-price-pulse">Price Pulse</Link>
            <Link to="/auto/registrations" className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-testid="nav-registrations">Registrations</Link>
            <Link to="/auto/blog" className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors">News</Link>
            <Link to="/auto/sell" className="text-sm font-medium text-[hsl(10,80%,55%)] hover:text-[hsl(10,80%,45%)] transition-colors flex items-center gap-1" data-testid="nav-sell">
              <Plus className="w-3.5 h-3.5" /> Sell
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <SiteSwitcher className="md:hidden text-gray-600" />
            {user ? (
              <>
                <SiteLink to={user.role === 'admin' || user.role === 'super_admin' ? '/admin/dashboard' : user.role === 'affiliate' ? '/affiliate/dashboard' : '/app/dashboard'} site="admin">
                  <Button variant="outline" size="sm" className="rounded-md" data-testid="dashboard-link">Dashboard</Button>
                </SiteLink>
                <Button variant="ghost" size="sm" onClick={logout} className="text-gray-500 hover:text-red-500" data-testid="logout-btn">
                  <LogOut className="w-4 h-4" />
                </Button>
              </>
            ) : (
              <>
                <SiteLink to="/admin?redirect=auto" site="admin" data-testid="login-link"><Button variant="ghost" size="sm">Login</Button></SiteLink>
                <SiteLink to="/admin?redirect=auto" site="admin" data-testid="signup-link">
                  <Button size="sm" className="bg-[hsl(10,80%,55%)] hover:bg-[hsl(10,80%,45%)] text-white rounded-md">Sign Up</Button>
                </SiteLink>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export function AutoFooter() {
  return (
    <NetworkFooter
      activeSite="auto"
      bgClass="bg-[hsl(0,0%,7%)]"
      disclaimer="Vehicle prices, specifications, and availability shown are approximate and for reference only. Actual prices may vary."
    />
  );
}
